import PropTypes from 'prop-types';
import React from 'react';

import gridStyles from 'assets/style/grid.module.css';
import clsx from 'clsx';

import ContentSection from 'js/pages/TreatmentPage/ContentSection';
import InfoBlock from 'js/components/InfoColumnBlocks/InfoBlock';
import InfoColumnBlocks from 'js/components/InfoColumnBlocks';
import treatmentTypeToBlock from 'js/components/InfoColumnBlocks/transform/treatment-type';
import venueTypeToBlock from 'js/components/InfoColumnBlocks/transform/venue-type';
import inspirationArticleToBlock from 'js/components/InfoColumnBlocks/transform/inspiration-article';
import { useTrackPageAndSessionView } from 'js/hooks/useTrackPageAndSessionView';
import styles from './TreatmentGuidePageStyles.module.css';
import { Context } from '../../components/LocaleWrapper';

const TreatmentGuidePage = () => {
  useTrackPageAndSessionView();
  const {
    generateUri,
    getMediaUri,
    i18n,
    pageData: { treatmentGuide },
  } = React.useContext(Context);
  const treatmentTypes = treatmentTypeToBlock(
    treatmentGuide.treatmentTypes || [],
    generateUri,
    i18n
  );
  const venueTypes = venueTypeToBlock(
    treatmentGuide.venueTypes || [],
    generateUri,
    i18n
  );
  const inspirationArticles = inspirationArticleToBlock(
    treatmentGuide.inspirationArticles || []
  );

  const heroImage = getMediaUri(
    i18n('page.treatment-guide.hero.background-image')
  );
  const bgColorFrom = i18n('page.treatment-guide.hero.background-color-from');
  const bgColorTo = i18n('page.treatment-guide.hero.background-color-to');
  const backgroundGradient = () => {
    const from = bgColorFrom || bgColorTo;
    const to = bgColorTo || bgColorFrom;

    return from && to
      ? `
        .${styles.header} {
          background-image: linear-gradient(to bottom, ${from}, ${to})
        }
      `
      : '';
  };

  return (
    <div className={styles.treatmentGuide}>
      <div className={styles.header}>
        <style>{backgroundGradient()}</style>
        <ContentSection>
          <div
            className={clsx(gridStyles['col-xs-12'], gridStyles['col-sm-6'])}
          >
            <h1 className={styles.title}>
              {i18n('page.treatment-guide.title')}
            </h1>
            <div className={styles.description}>
              {i18n('page.treatment-guide.description')}
            </div>
          </div>
        </ContentSection>
      </div>
      <div
        className={clsx(styles.heroimage)}
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <ContentSection>
          <div className={styles.contentBlocks}>
            <InfoColumnBlocks
              blocks={treatmentTypes}
              contentBlock={InfoBlock}
            />
          </div>
        </ContentSection>
      </div>
      <ContentSection>
        <div className={styles.contentBlocks}>
          <InfoColumnBlocks
            title={i18n('page.treatment-guide.section-venue-type')}
            blocks={venueTypes}
            contentBlock={InfoBlock}
          />
        </div>
      </ContentSection>

      {inspirationArticles ? (
        <ContentSection>
          <div className={styles.contentBlocks}>
            <InfoColumnBlocks
              title={i18n('page.treatment-guide.section-inspiration-articles')}
              blocks={inspirationArticles}
              contentBlock={InfoBlock}
            />
          </div>
        </ContentSection>
      ) : null}
    </div>
  );
};

TreatmentGuidePage.propTypes = {
  treatmentGuide: PropTypes.object,
};

export default TreatmentGuidePage;
